import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

import type { ClaimWithRelations } from "../../api/use-claim";
import { useCreateOnePager } from "../../api/use-claim-actions";
import { CtaShell } from "./cta-shell";

/** Port of states-cta/OnePagerCTA.vue — génération du One-Pager. */
export function OnePagerCTA({ claim }: { claim: ClaimWithRelations }) {
  const [isMediationOnePager, setIsMediationOnePager] = useState(false);
  const createOnePager = useCreateOnePager(claim.id);

  return (
    <CtaShell legalStepName={claim.claimLegalStep.name}>
      <p className="mt-4 text-sm leading-6 text-gray-500">
        <span className="leading-8 font-semibold text-gray-900">
          Générer le One-Pager
          <br />
        </span>
        <span className="font-semibold text-slate-600">
          Document récapitulatif du dossier pour la procédure.
        </span>
      </p>

      <div className="py-6">
        <Label className="mb-3 flex cursor-pointer items-center gap-2">
          <Checkbox
            checked={isMediationOnePager}
            onCheckedChange={(checked) => setIsMediationOnePager(checked === true)}
          />
          <span className="text-sm font-medium text-gray-900">Dossier de médiation</span>
        </Label>
        <Button
          onClick={() => createOnePager.mutate({ isMediation: isMediationOnePager })}
          disabled={createOnePager.isPending}
        >
          Générer le One-Pager
        </Button>
      </div>
    </CtaShell>
  );
}
